import React from "react";
import { Controller, ControllerProps } from "react-hook-form";
import {
	Checkbox, CheckboxProps,
	FormControlLabel, FormControlLabelProps
} from "@mui/material";

export interface CheckboxControlProps extends
	Omit<ControllerProps<any, any>, "defaultValue" | "name" | "render">,
	CheckboxProps
{
	label?: React.ReactNode,
	helperText?: React.ReactNode,
	labelPlacement?: FormControlLabelProps['labelPlacement'],
	FormControlLabelProps?: FormControlLabelProps
}

export function CheckboxControl(props: CheckboxControlProps) {
	const {
		control,
		disabled,
		defaultValue,
		name,
		rules,
		shouldUnregister,
		label,
		labelPlacement,
		helperText,
		...checkboxProps
	} = props;
	return (
		<Controller
			control={control}
			defaultValue={defaultValue}
			name={name}
			render={renderProps => {
				const { field, fieldState, formState } = renderProps;
				return (
					<FormControlLabel
						label={label}
						labelPlacement={labelPlacement || 'end'}
						//error={Boolean(fieldState.error)}
						disabled={disabled || formState.isSubmitting}
						control={(
							<Checkbox
								{...checkboxProps}
								checked={checkboxProps.checked ?? field.value}
								//disabled={}
								//helperText={fieldState.error?.message ?? helperText}
								name={field.name}
								onBlur={e => {
									checkboxProps.onBlur?.(e);
									field.onBlur();
								}}
								onChange={e => {
									const checked = e.target?.checked;
									checkboxProps.onChange?.(e, checked);
									field.onChange({
										name: field.name,
										target: {
											...e.target,
											checked,
											value: checked
										}
									});
								}}
								value={checkboxProps.value}
							/>
						)}
					/>
				);
			}}
			rules={rules}
			shouldUnregister={shouldUnregister}
		/>
	);
}
